module.exports = __webpack_public_path__ + "img/markBGI4.2cb4fa60.png";